"use client";

import React from "react";

import { LANGUAGES, type LanguageCode } from "@/data/core";
import { Tooltip } from "@/components/ui/tooltip";

const FLAG_EMOJI: Record<LanguageCode, string> = {
  en: "🇬🇧",
  de: "🇩🇪",
};

/**
 * Displays a language flag with the localized language name in a tooltip.
 *
 * The tooltip behavior is delegated to the shared Tooltip component so language
 * flags behave consistently with hints, badges and other passive metadata.
 */
export function LanguageFlag({ code }: { code: LanguageCode }) {
  const label = LANGUAGES[code];

  return (
    <Tooltip content={label} interaction="toggle" side="bottom">
      <button
        type="button"
        aria-label={label}
        className="focus-visible:ring-ring/70 inline-flex h-7 cursor-help touch-manipulation items-center rounded-sm focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent focus-visible:outline-none"
      >
        <span
          className="block text-2xl leading-none [text-shadow:0_0_2px_#fff]"
          role="img"
          aria-hidden="true"
        >
          {FLAG_EMOJI[code]}
        </span>
      </button>
    </Tooltip>
  );
}
